import { Component, OnInit } from '@angular/core';
import { CotacaoService } from '../../shared/Services/CotacaoService/cotacao-service.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LogInService } from '../../shared/Services/LoginService/log-in.service';
import { GetAccountDataService } from '../../shared/Services/GetAccountData/get-account-data.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { NgbCalendar, NgbDate, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { formatDate } from '@angular/common';
import { ModalMensajeComponent } from '../modal-mensaje/modal-mensaje.component';
import { NgbDateCustomParserFormatter } from '../../shared/utils/dateformat';
import { CommonService } from '../../shared/Services/Common/common.service';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { GetCupomService } from '../../shared/Services/GetCupom/get-cupom.service';
import { Pais } from 'src/app/shared/Interfaces/Pais';

@Component({
  selector: 'app-fazer-cotacao',
  templateUrl: './fazer-cotacao.component.html',
  styleUrls: ['./fazer-cotacao.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class FazerCotacaoComponent implements OnInit {

  // tslint:disable-next-line: ban-types
  tipoProduto: String = '';

  dataIda: NgbDate;
  dataRetorno: NgbDate;
  date: { year: number, month: number };

  displayMonths = 2;
  navigation = 'select';
  showWeekNumbers = false;
  outsideDays = 'visible';
  minDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');

  listPaises: Pais[];
  listPaisesSinFiltrar: Pais[];
  listEstados: [];
  listPassageiros: [];
  // tslint:disable-next-line: ban-types
  motivoViagem: String = 'L';

  imagePath: string;
  cupom: string;
  bonificacion: number;
  telefono: string;
  ShowImage: boolean;
  ShowTelefono: boolean;
  ShowEmail: boolean;
  ShowCupon: boolean;
  submitted: boolean;
  showDestino: boolean;
  showOrigem: boolean;
  showIda: boolean;
  showVolta: boolean;
  CupomInicio: string;
  CupomFim: string;
  showPassageiroMenor: boolean;
  showPassageiroMaior: boolean;
  showQuantDias: boolean;
  email: any;
  ambiente: any;
  minDataIda: object;

  selectedOrigem: any;
  selectedDestino: any;
  selectedDataIda: any;
  selectedVolta: any;

  cotacaoForm: FormGroup = new FormGroup({
    origem: new FormControl('', [Validators.required, Validators.minLength(1)]),
    destino: new FormControl('', [Validators.required, Validators.minLength(1)]),
    incluiEuropa: new FormControl({ value: '', required: true }),
    dataIda: new FormControl('', [Validators.required, Validators.minLength(1)]),
    dataVolta: new FormControl('', [Validators.required, Validators.minLength(1)]),
    quantPassageirosMenor: new FormControl('', [Validators.required]),
    quantPassageirosMaior: new FormControl('', [Validators.required]),
    quantDias: new FormControl({ value: '', required: true })
  });

  constructor(private cotacaoService: CotacaoService,
    private logInService: LogInService,
    private getAccountDataService: GetAccountDataService,
    private navigate: Router,
    private router: ActivatedRoute,
    private calendar: NgbCalendar,
    private route: ActivatedRoute,
    private routers: Router,
    private modalService: NgbModal,
    private commonService: CommonService,
    private getCupomService: GetCupomService,
    private config: NgbDatepickerConfig
  ) {
    const current = new Date();
    this.minDataIda = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

  }

  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.removeItem('Cupom');
    sessionStorage.removeItem('Bonificacion');
    this.cotacaoForm.disable();
    const urlParams = decodeURI(location.href.split('?')[1]);
    localStorage.setItem('URLCotizacion', urlParams);
    this.router.queryParams.subscribe(params => {
      this.ambiente = params.ambiente ? params.ambiente : 'OS';
      localStorage.setItem('ambiente', this.ambiente ? this.ambiente : 'OS');
      localStorage.setItem('URLParams', JSON.stringify(params));
      sessionStorage.setItem('params', JSON.stringify(params));
      this.GetSessionIDBySellerID(params).then((resolve) => {
        this.ShowCupon = (!isNullOrUndefined(this.cupom));
        this.telefono = sessionStorage.getItem('Telefone');
        this.ShowTelefono = (!isNullOrUndefined(this.telefono));
      });
      this.obterPaises();
      this.obterEstados();
      this.obterPassageiros();
    });
  }

  get f() { return this.cotacaoForm.controls; }

  changeTipoProduto(ev: any) {
    this.cotacaoForm.enable();
    switch (this.tipoProduto) {
      case 'MV':
        this.cotacaoForm.get('destino').disable();
        this.cotacaoForm.get('incluiEuropa').disable();
        this.listPaises = this.listPaisesSinFiltrar.filter(data => data.ISO3L === 'MUL');
        break;
      case 'VN':
        this.cotacaoForm.get('destino').disable();
        this.cotacaoForm.get('incluiEuropa').disable();
        this.listPaises = this.listPaisesSinFiltrar.filter(data => data.ISO3L === 'BRA');
        break;
      default:
        {
          this.cotacaoForm.get('destino').enable();
          this.cotacaoForm.get('incluiEuropa').enable();
          this.listPaises = this.listPaisesSinFiltrar.filter(data => data.ISO3L !== 'BRA' && data.ISO3L !== 'xxx' && data.ISO3L !== 'MUL');
          break;
        }
    }
    this.motivoViagem = (this.tipoProduto === 'MV' && 'M') || 'L';
  }

  selectChangeHandler(event: any) {
    const index = event.target.options.selectedIndex;
    if (event.target.name === 'origem_viagem') {
      this.selectedOrigem = event.target.options[index].text;
    } else {
      this.selectedDestino = event.target.options[index].text;
    }
  }

  fazerCotacao() {
    this.submitted = true;
    this.VerifyDestino();
    this.VerifyOrigem();
    this.VerifyIda();
    this.VerifyVolta();
    this.VerifyPassageiroMaior();
    this.VerifyPassageiroMenor();
    this.VerifyquantDias();
    console.log('Session ID', sessionStorage.SessionID);
    if (this.cotacaoForm.invalid) {
      return;
    }
    const dadosCotacao = this.cotacaoForm.value;
    if (dadosCotacao.quantDias == null) {
      dadosCotacao.quantDias = 0;
    }
    let codigoTipoProducto: string;

    if (this.tipoProduto === 'VN') {
      dadosCotacao.destino = 'BRA';
    }
    if (dadosCotacao.destino === 'BRA') {
      codigoTipoProducto = 'VN';
    }
    if (dadosCotacao.destino !== 'BRA') {
      codigoTipoProducto = 'VI';
    }
    if (this.motivoViagem === 'M') {
      codigoTipoProducto = 'MV';
      localStorage.setItem('codigoTipoProducto', JSON.stringify(codigoTipoProducto));
      localStorage.setItem('MotivoViaje', 'Multi Viagem');
      dadosCotacao.quantPassageirosMaior = 0;
      this.inicioVigencia();
    }

    ////  FILTROS DE FECHAS

    const hoje = moment();
    hoje.subtract(1, 'days');

    const dataIda = moment(dadosCotacao.dataIda.year + '-' + String(dadosCotacao.dataIda.month).padStart(2, '0') + '-' + String(dadosCotacao.dataIda.day).padStart(2, '0')).unix();
    const dataVolta = moment(dadosCotacao.dataVolta.year + '-' + String(dadosCotacao.dataVolta.month).padStart(2, '0') + '-' + String(dadosCotacao.dataVolta.day).padStart(2, '0')).unix();
    //// NO TOMA DATA IDA COMO
    if (dataIda < hoje.unix() || dataVolta < hoje.unix()) {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
      modalRef.componentInstance.Titulo = 'Error data';
      modalRef.componentInstance.Mensaje = 'As datas não podem ser menores que as atuais';
      // this.cotacaoForm.reset();
      localStorage.clear();
      return;
    }
    if (dataVolta <= dataIda) {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
      modalRef.componentInstance.Titulo = 'Error data';
      modalRef.componentInstance.Mensaje = 'A data de volta deve ser maior que a data de ida';
      // localStorage.clear();
      return;
    }

    if (this.motivoViagem === 'M') {
      // debugger
      dadosCotacao.dataVolta = dadosCotacao.dataIda;
      // tslint:disable-next-line: max-line-length
      let dataVoltaAux = moment(dadosCotacao.dataVolta.year + '-' + String(dadosCotacao.dataVolta.month).padStart(2, '0') + '-' + String(dadosCotacao.dataVolta.day).padStart(2, '0'), 'YYYY-MM-DD').add(364, 'days');
      localStorage.setItem('dataVoltaAux', dataVoltaAux.format('YYYY-MM-DD'));
      dadosCotacao.destino = 'MUL';
    }
    if (this.motivoViagem === 'L') {
      localStorage.setItem('codigoTipoProducto', JSON.stringify(codigoTipoProducto));
      localStorage.setItem('MotivoViaje', 'Lazer / Negocios ');
      const volta = dadosCotacao.dataVolta.year + '-' + dadosCotacao.dataVolta.month + '-' + dadosCotacao.dataVolta.day;
      const ida = dadosCotacao.dataIda.year + '-' + dadosCotacao.dataIda.month + '-' + dadosCotacao.dataIda.day;
      const totalDias = moment(volta).diff(moment(ida), 'days');
      // console.log('TOTAL DE DIAS: ', totalDias);
      if (totalDias > 120) {
        this.motivoViagem = 'I';
        const opcion: boolean = confirm('O produto mais adequado para viagens com duração maior que 120 dias é o itercâmbio');
        if (!opcion) {
          this.motivoViagem = 'L';
        }
        localStorage.clear();
        return;
      }
    }
    if (this.motivoViagem === 'E') {
      localStorage.setItem('codigoTipoProducto', JSON.stringify(codigoTipoProducto));
      localStorage.setItem('MotivoViaje', 'Esportes / Competição amadora ');
      const volta = dadosCotacao.dataVolta.year + '-' + dadosCotacao.dataVolta.month + '-' + dadosCotacao.dataVolta.day;
      const ida = dadosCotacao.dataIda.year + '-' + dadosCotacao.dataIda.month + '-' + dadosCotacao.dataIda.day;
      let totalDias = moment(volta).diff(moment(ida), 'days');
      console.log('TOTAL DE DIAS: ', totalDias);
      if (totalDias > 120) {

        const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });

        modalRef.componentInstance.Titulo = 'Error data';
        modalRef.componentInstance.Mensaje = 'O prazo maximo em ESPORTES é de 120 dias';
        return;
      }
    }
    if (this.motivoViagem === 'I') {
      localStorage.setItem('codigoTipoProducto', JSON.stringify(codigoTipoProducto));
      localStorage.setItem('MotivoViaje', 'Estudos / Intercâmbio ');
    }

    if (!this.tipoProduto || this.tipoProduto === '') {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });

      modalRef.componentInstance.Titulo = 'Erro de dados';
      modalRef.componentInstance.Mensaje = 'Deve selecionar um tipo de produto';
      return;
    }

    var cupom = sessionStorage.getItem('Cupom');
    console.log('this.cotacaoForm.value: ', this.cotacaoForm.value);

    // this.cotacaoService.FazerCotacao("USA", "L", 0, "2020-03-10", "2020-03-20", 0, 1, "", 0, "VI", sessionStorage.SessionID)
    this.cotacaoService.FazerCotacao(
      dadosCotacao.destino,
      this.motivoViagem,
      this.cotacaoForm.value.incluiEuropa ? 1 : 0,
      dadosCotacao.dataIda.year + '-' + String(dadosCotacao.dataIda.month).padStart(2, '0') + '-' + String(dadosCotacao.dataIda.day).padStart(2, '0'),
      dadosCotacao.dataVolta.year + '-' + String(dadosCotacao.dataVolta.month).padStart(2, '0') + '-' + String(dadosCotacao.dataVolta.day).padStart(2, '0'),
      this.cotacaoForm.value.quantPassageirosMaior,
      this.cotacaoForm.value.quantPassageirosMenor,
      cupom,
      (codigoTipoProducto === 'MV') ? dadosCotacao.quantDias : 0,
      this.tipoProduto,
      sessionStorage.SessionID
    ).subscribe(
      data => {
        if (data.ResponseJSONData !== '' && data.ResponseJSONData !== undefined) {
          localStorage.setItem('CuponUsado', cupom);
          localStorage.setItem('Origem', JSON.stringify(dadosCotacao.origem));
          localStorage.setItem('Cotizacion', JSON.stringify(data.ResponseJSONData));
          if (this.motivoViagem.toString() !== 'M') {
            this.cotacaoForm.value.quantDias = 0;
          }
          localStorage.setItem('dadosCotizacionL', JSON.stringify(this.cotacaoForm.value));
          localStorage.setItem('MotivoViagem', this.motivoViagem.toString());
          localStorage.setItem('DescripcionOrigem', this.selectedOrigem);
          localStorage.setItem('DescripcionDestino', (this.tipoProduto == 'VI' && this.selectedDestino) || (this.tipoProduto == 'VN' && 'Brasil') || (this.tipoProduto === 'MV' && 'Multidestinos'));
          if (JSON.stringify(data.ResponseJSONData) === '') {
            console.log('Data vacia');
            const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
            modalRef.componentInstance.Titulo = 'Error data';
            modalRef.componentInstance.Mensaje = 'Por gentileza verificar os campos inseridos';
            // this.routers.navigate(['/not-found']);
          } else {
            if (isNullOrUndefined(cupom)) {
              localStorage.setItem('CotizacionSinCupon', JSON.stringify(data.ResponseJSONData));
              this.routers.navigate(['/MostrarProdutos']);
            } else {
              this.cotacaoService.FazerCotacao(
                  dadosCotacao.destino,
                  this.motivoViagem,
                  this.cotacaoForm.value.incluiEuropa ? 1 : 0,
                  dadosCotacao.dataIda.year + '-' + String(dadosCotacao.dataIda.month).padStart(2, '0') + '-' + String(dadosCotacao.dataIda.day).padStart(2, '0'),
                  dadosCotacao.dataVolta.year + '-' + String(dadosCotacao.dataVolta.month).padStart(2, '0') + '-' + String(dadosCotacao.dataVolta.day).padStart(2, '0'),
                  dadosCotacao.quantPassageirosMaior,
                  dadosCotacao.quantPassageirosMenor,
                  '',
                  (codigoTipoProducto === 'MV') ? dadosCotacao.quantDias : 0,
                  codigoTipoProducto,
                  sessionStorage.SessionID)
                .subscribe(
                  data2 => {
                    localStorage.setItem('CotizacionSinCupon', JSON.stringify(data2.ResponseJSONData));
                    this.routers.navigate(['/MostrarProdutos']);
                  });
            }
          }
        } else {
          const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
          modalRef.componentInstance.Titulo = 'Error data';
          modalRef.componentInstance.Mensaje = 'Por gentileza verificar os campos inseridos';
        }
      }
    );
    // this.navigate.navigate(['/MostrarProdutos']);
  }

  GetSessionIDBySellerID(params): Promise < boolean > {
    this.logInService.GetToken(params.SalesChannelType, decodeURI(params.SalesChannelCode), params.UserName)
    .subscribe(
      data => {
        // tslint:disable-next-line: max-line-length
        let responseCode = JSON.parse(data.ResponseJSONData)['s:Envelope']['s:Body'].GetLoginTokenBySellerIDResponse.GetLoginTokenBySellerIDResult.MessageCode['#text'];
        if (responseCode === '0') {
          // tslint:disable-next-line: max-line-length
          sessionStorage.setItem('Token', (JSON.parse(data.ResponseJSONData)['s:Envelope']['s:Body'].GetLoginTokenBySellerIDResponse.GetLoginTokenBySellerIDResult['a:Token']));
          // tslint:disable-next-line: max-line-length
          this.logInService.GetSessionID(JSON.parse(data.ResponseJSONData)['s:Envelope']['s:Body'].GetLoginTokenBySellerIDResponse.GetLoginTokenBySellerIDResult['a:Token'])
            .subscribe(
              SessionID => {
                // tslint:disable-next-line: max-line-length
                sessionStorage.setItem("Flag", JSON.stringify(SessionID));

                sessionStorage.setItem('SessionID', SessionID.ResponseJSONData.SessionID);

                this.getAccountDataService.GetAccountData(params.SalesChannelCode, '0', '0', params.UserName)
                  .subscribe(
                    data2 => {
                      console.log('data2: ', data2);
                      this.imagePath = (data2.ResponseJSONData)[0].HeaderHTML;

                      const regex = /<img.*?src="(.*?)"/;
                      let src;
                      if (this.imagePath && this.imagePath !== '') {
                        const regexEval = regex.exec(this.imagePath);
                        src = regexEval ? regexEval[1] : null;
                      }
                      this.imagePath = src;
                      let accountData = (data2.ResponseJSONData)[0];

                      sessionStorage.setItem('HeaderHTML', accountData.HeaderHTML);
                      sessionStorage.setItem('Telefone', accountData.Telefone);
                      sessionStorage.setItem('EMail', accountData.EMail);
                      sessionStorage.setItem('UserID', accountData.UserID);
                      this.commonService.changeRazonSocial(accountData.RazonSocial);
                      this.commonService.changeEmail(accountData.EMail);
                      this.commonService.changeTelefono(accountData.Telefone);
                      this.commonService.changeImagePath(src);

                      if (accountData.Cupom !== '') {
                        this.getCupomService.GetCupom(sessionStorage.SessionID)
                          .subscribe(
                            data1 => {
                              if ((data1.ResponseJSONData) !== '' || (data1.ResponseJSONData) !== undefined) {
                                const resultado = data1.ResponseJSONData.find(cu => cu.CodigoCupon === accountData.Cupom);
                                const hoje = moment().format('YYYY-MM-DD');
                                const inicioCupom = moment(resultado.FechaInicioVigencia).format('YYYY-MM-DD');
                                const finCupom = moment(resultado.FechaFinVigencia).format('YYYY-MM-DD');

                                if (moment(inicioCupom).isAfter(hoje) || moment(finCupom).isBefore(hoje)) {
                                  this.cupom = '';
                                  this.bonificacion = 0;
                                  sessionStorage.setItem('Cupom', accountData.Cupom);
                                  sessionStorage.setItem('Bonificacion', accountData.Bonificacion);
                                  const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
                                  modalRef.componentInstance.Titulo = 'Atenção';
                                  // tslint:disable-next-line: max-line-length
                                  modalRef.componentInstance.Mensaje = 'O cupom só pode ser usado de ' + moment(resultado.FechaInicioVigencia).format('DD-MM-YYYY') + ' até ' + moment(resultado.FechaFinVigencia).format('DD-MM-YYYY');
                                } else {
                                  this.cupom = accountData.Cupom;
                                  this.bonificacion = accountData.Bonificacion;
                                  sessionStorage.setItem('Cupom', accountData.Cupom);
                                  sessionStorage.setItem('Bonificacion', accountData.Bonificacion);
                                }
                              } else {
                                this.cupom = '';
                                this.bonificacion = 0;
                                sessionStorage.setItem('Cupom', accountData.Cupom);
                                sessionStorage.setItem('Bonificacion', accountData.Bonificacion);
                                const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
                                modalRef.componentInstance.Titulo = 'Error data';
                                modalRef.componentInstance.Mensaje = 'O cupom não existe';
                              }

                              return Promise.resolve(true);
                            },
                            err => {
                              this.navigate.navigate(['/404']);
                              return Promise.resolve(false);
                            });
                      } else {
                        sessionStorage.setItem('Cupom', accountData.Cupom);
                        sessionStorage.setItem('Bonificacion', accountData.Bonificacion);
                        this.cupom = accountData.Cupom;
                        this.bonificacion = accountData.Bonificacion;

                        return Promise.resolve(true);
                      }
                    },
                    err => {
                      this.navigate.navigate(['/404']);
                      return Promise.resolve(false);
                    });
              },
              err => {
                this.navigate.navigate(['/404']);
                return Promise.resolve(false);
              });
        } 
        else {
          this.navigate.navigate(['/404']);
          return Promise.resolve(false);
        }
      },
      err => {
        this.navigate.navigate(['/404']);
        return Promise.resolve(false);
      });
      return Promise.resolve(true);
  }

  obterPassageiros() {
    this.cotacaoService.ConsultaQuantidadePassageiros()
      .subscribe(
        data => {
          this.listPassageiros = data.ResponseJSONData;
          // console.log('lista pasajeros ', this.listPassageiros);
        }
      );
  }

  GetDate(): Date {
    return new Date();
  }

  obterPaises() {
    this.cotacaoService.ConsultaPaises()
      .subscribe(
        data => {
          this.listPaisesSinFiltrar = data.ResponseJSONData;
          // console.log('Paises: ', this.listPaises);
        }
      );
  }

  obterEstados() {
    this.cotacaoService.ConsultaEstados()
      .subscribe(
        data => {
          this.listEstados = data.ResponseJSONData;
          // console.log('Estados: ', this.listEstados);
        }
      );
  }

  cambiarMotivoViagem(param) {
    this.motivoViagem = param;
    if (param === 'M') {
      this.cotacaoForm.enable();
      this.tipoProduto = 'MV';
      this.cotacaoForm.get('destino').disable();
      this.cotacaoForm.get('incluiEuropa').disable();
    }
  }

  inicioVigencia() {
    const data = this.cotacaoForm.value.dataIda;
    const fechaVto = moment(data.days).add(365, 'days').format('DD/MM/YYYY');
    this.cotacaoForm.value.dataVolta = fechaVto;
  }

  VerifyDestino() {
    const destinoCotacao = this.cotacaoForm.value.destino;
    this.showDestino = (!destinoCotacao || destinoCotacao === '');
  }

  VerifyOrigem() {
    const origemCotacao = this.cotacaoForm.value.origem;
    this.showOrigem = (!origemCotacao || origemCotacao === '');
  }

  VerifyIda() {
    const idaCotacao = this.cotacaoForm.value.dataIda;
    this.showIda = (!idaCotacao || idaCotacao === '');
  }

  VerifyVolta() {
    if (this.tipoProduto === 'MV') {
      this.cotacaoForm.controls['dataVolta'].setValidators(null);
      this.cotacaoForm.controls['dataVolta'].setValue('');

      const dataVoltaViagem = moment(this.cotacaoForm.value.dataIda).add(364, 'days');
      this.cotacaoForm.value.dataVolta = {
        year: dataVoltaViagem.year(),
        month: dataVoltaViagem.month(),
        day: dataVoltaViagem.date()
      };
      const voltaCotacao = this.cotacaoForm.value.dataVolta;
      this.showVolta = (!voltaCotacao || voltaCotacao === '');
    } else {
      const voltaCotacao = this.cotacaoForm.value.dataVolta;
      this.showVolta = (!voltaCotacao || voltaCotacao === '');
    }
  }

  VerifyPassageiroMaior() {
    const PassageiroMaior = this.cotacaoForm.value.quantPassageirosMaior;
    this.showPassageiroMaior = (!PassageiroMaior || PassageiroMaior === '');
  }

  VerifyPassageiroMenor() {
    const PassageiroMenor = this.cotacaoForm.value.quantPassageirosMenor;
    this.showPassageiroMenor = (!PassageiroMenor || PassageiroMenor === '');
  }

  VerifyquantDias() {
    const quantDias = this.cotacaoForm.value.quantDias;
    this.showQuantDias = (!quantDias || quantDias === '');
  }
}
